module.exports = __webpack_public_path__ + "img/inspiration-1.5849916.jpg";